import { Component } from '@angular/core';
import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-predictor-leaderboard-page',
  templateUrl: './predictor-leaderboard-page.component.html',
  styleUrl: './predictor-leaderboard-page.component.scss',
})
export class PredictorLeaderboardPageComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.PredictorPoints;
}
